import axios from "./instance";
import axiosCross from "./axiosCross";
//联系人
export const contact = () => {
  return axios({
    method: "get",
    url: "/contacts"
  });
};
//-----------------------后台相关
export const user_login = ({ user, pass }) => {
  return axios({
    method: "post",
    url: "/be/login",
    data: {
      user,
      pass
    }
  });
};
export const user_logout = () => {
  return axios({
    method: "delete",
    url: "/be/login"
  });
};
export const user_register = ({ user, pass, phone, name, email }) => {
  return axios({
    method: "post",
    url: "/be/register",
    data: {
      user,
      pass,
      phone,
      name,
      email
    }
  });
};
//删除用户
export const user_destroy = id => {
  return axios({
    method: "delete",
    url: `/be/users/${id}`
  });
};
//获取用户详情
export const user_detail = id => {
  return axios({
    method: "get",
    url: `/be/users/${id}`
  });
};
//更新用户
export const user_put = ({ id, userlevel, validStatus }) => {
  console.log(id, userlevel, validStatus);
  return axios({
    method: "PUT",
    url: `/be/users_updata`,
    data: {
      id,
      userlevel,
      validStatus
    }
  });
};
//用户列表
export const user_list = () => {
  return axios({
    method: "get",
    url: "/be/users"
  });
};
//状态监测
export const user_check = () => {
  return axios({
    method: "get",
    url: "/be/check"
  });
};
//oss签名
export const oss_sign = () => {
  return axios({
    method: "get",
    url: "/be/ossSign"
  });
};
//指定 参会人员信息
export const meetingUser = (acType, acId, sms, status, timeType) => {
  return axios({
    method: "get",
    url: `/meeting/users/${acType}/${acId}/${sms}/${status}/${timeType}`
  });
};
//sms参会信息导出
export const sms_file_count = (type, id) => {
  return axios.get(`/file/${type}/${id}`);
};
//所有参会人员信息
export const ac_user_list = () => {
  return axios({
    method: "get",
    url: "/meeting/users"
  });
};
//审核指定id参会人员
export const ac_user_review = (type, id, acid, acType) => {
  return axios({
    method: "put",
    url: `/ac/users/${type}/${id}/${acid}/${acType}`
  });
};
//---------------hkstocks--------------------
export const hkstocks_counts = id => {
  return axios({
    method: "get",
    url: `/hkstocks/count/${id}`
  });
};
//hkstock 指定活动id信息
export const hkstocks_detail = id => {
  return axios({
    method: "get",
    url: `/ac/hkstocks/${id}`
  });
};
//更新指定活动信息
export const hkstocks_put = ({
  id,
  title,
  city,
  address,
  position,
  startTime,
  expireTime,
  limit,
  status,
  header,
  footer,
  coOrganizers,
  supporters,
  Ssponsorship,
  supportMeadia,
  mediaPartners,
  dtbShow,
  msgShow,
  titbitShow,
  aganda_am_pc,
  aganda_am_mb,
  aganda_pm_pc,
  aganda_pm_mb,
  videoType
}) => {
  return axios({
    method: "put",
    url: `/ac/hkstocks/${id}`,
    data: {
      title,
      city,
      address,
      position,
      startTime,
      expireTime,
      limit,
      status,
      header,
      footer,
      coOrganizers,
      supporters,
      Ssponsorship,
      supportMeadia,
      mediaPartners,
      dtbShow,
      msgShow,
      titbitShow,
      aganda_am_pc,
      aganda_am_mb,
      aganda_pm_pc,
      aganda_pm_mb,
      videoType
    }
  });
};
//hkstock列表
export const hkstocks_list = () => {
  return axios({
    method: "get",
    url: "/ac/hkstocks"
  });
};
//发布hkstocks活动信息
export const hkstocks_post = ({
  title,
  city,
  address,
  position,
  startTime,
  expireTime,
  limit,
  status = 1,
  header,
  footer,
  coOrganizers,
  supporters,
  Ssponsorship,
  supportMeadia,
  mediaPartners,
  dtbShow,
  msgShow,
  titbitShow,
  aganda_am_pc,
  aganda_am_mb,
  aganda_pm_pc,
  aganda_pm_mb,
  videoType
}) => {
  return axios({
    method: "post",
    url: "/ac/hkstocks",
    data: {
      title,
      city,
      address,
      position,
      startTime,
      expireTime,
      limit,
      status,
      header,
      footer,
      coOrganizers,
      supporters,
      Ssponsorship,
      supportMeadia,
      mediaPartners,
      dtbShow,
      msgShow,
      titbitShow,
      aganda_am_pc,
      aganda_am_mb,
      aganda_pm_pc,
      aganda_pm_mb,
      videoType
    }
  });
};
export const qsmsService = ({
  user,
  phone,
  title,
  time,
  timeWeek,
  timeDate,
  position,
  address,
  id,
  acid,
  userid,
  nationCode,
  smsType,
  tplId
}) => {
  return axios({
    method: "POST",
    url: `/qsmsService`,
    data: {
      id,
      title,
      timeWeek,
      user,
      phone,
      time,
      timeDate,
      position,
      address,
      acid,
      userid,
      nationCode,
      smsType,
      tplId
    }
  });
};

export const qsmsServiceSingeSend = ({
  id,
  phoneNumber,
  msg,
  msgType,
  nationCode,
  extend,
  ext,
  smsType
}) => {
  return axios({
    method: "POST",
    url: `/qsmsServiceSingeSend`,
    data: {
      id,
      phoneNumber,
      msg,
      msgType,
      nationCode,
      extend,
      ext,
      smsType
    }
  });
};
export const hkstocks_active = ({ id, active }) => {
  return axios({
    method: "PUT",
    url: `/ac/hkstocksactive`,
    data: {
      id,
      active
    }
  });
};
export const hkstocks_status = ({ id, status }) => {
  return axios({
    method: "PUT",
    url: `/ac/hkstocksstatus`,
    data: {
      id,
      status
    }
  });
};
//---------------freetalks--------------------
export const freetalks_counts = id => {
  return axios({
    method: "get",
    url: `/freetalks/count/${id}`
  });
};
//hkstock 指定活动id信息
export const freetalks_detail = id => {
  return axios({
    method: "get",
    url: `/ac/freetalks/${id}`
  });
};
//更新指定活动信息
export const freetalks_put = ({
  id,
  title,
  city,
  address,
  position,
  startTime,
  expireTime,
  limit,
  status,
  header,
  footer,
  stage
}) => {
  return axios({
    method: "put",
    url: `/ac/freetalks/${id}`,
    data: {
      title,
      city,
      address,
      position,
      startTime,
      expireTime,
      limit,
      status,
      header,
      footer,
      stage
    }
  });
};

export const freetalks_list = () => {
  return axios({
    method: "get",
    url: "/ac/freetalks"
  });
};
//发布freetalks活动信息
export const freetalks_post = ({
  title,
  city,
  address,
  position,
  startTime,
  expireTime,
  limit,
  status = 1,
  header,
  footer,
  stage
}) => {
  return axios({
    method: "post",
    url: "/ac/freetalks",
    data: {
      title,
      city,
      address,
      position,
      startTime,
      expireTime,
      limit,
      status,
      header,
      footer,
      stage
    }
  });
};
export const freetalks_status = ({ id, status }) => {
  return axios({
    method: "PUT",
    url: `/ac/freetalksstatus`,
    data: {
      id,
      status
    }
  });
};
//---------------roadshow--------------------
export const roadshow_counts = id => {
  return axios({
    method: "get",
    url: `/roadshow/count/${id}`
  });
};
//hkstock 指定活动id信息
export const roadshow_detail = id => {
  return axios({
    method: "get",
    url: `/ac/roadshow/${id}`
  });
};
//更新指定活动信息
export const roadshow_put = ({
  id,
  title,
  city,
  address,
  position,
  startTime,
  expireTime,
  limit,
  status,
  header,
  footer,
  stage,
  positionEN,
  addressEN
}) => {
  return axios({
    method: "put",
    url: `/ac/roadshow/${id}`,
    data: {
      title,
      city,
      address,
      position,
      startTime,
      expireTime,
      limit,
      status,
      header,
      footer,
      stage,
      positionEN,
      addressEN
    }
  });
};
export const roadshow_list = () => {
  return axios({
    method: "get",
    url: "/ac/roadshow"
  });
};
//发布roadshow活动信息
export const roadshow_post = ({
  title,
  city,
  address,
  position,
  startTime,
  expireTime,
  limit,
  status = 1,
  header,
  footer,
  stage,
  positionEN,
  addressEN
}) => {
  return axios({
    method: "post",
    url: "/ac/roadshow",
    data: {
      title,
      city,
      address,
      position,
      startTime,
      expireTime,
      limit,
      status,
      header,
      footer,
      stage,
      positionEN,
      addressEN
    }
  });
};
export const roadshow_status = ({ id, status }) => {
  return axios({
    method: "PUT",
    url: `/ac/roadshowstatus`,
    data: {
      id,
      status
    }
  });
};

//------------------------房地产高峰论坛
export const estateforum_summit_list = () => {
  return axios({
    method: "POST",
    url: "/ac/estateforum/list"
  });
};
export const estateforum_update_summit = ({
  id,
  title,
  city,
  date,
  limit,
  earlyBird,
  saverTpuicket,
  normalFare,
  status,
  ticketStatus
}) => {
  return axios({
    method: "PUT",
    url: "/ac/estateforum/update",
    data: {
      id,
      title,
      city,
      date,
      limit,
      earlyBird,
      saverTpuicket,
      normalFare,
      status,
      ticketStatus
    }
  });
};
export const estateforum_findbyid = ({ id }) => {
  return axios({
    method: "POST",
    url: "/ac/estateforum/findbyid",
    data: {
      id
    }
  });
};
export const estateforum_company_info_list = ({ acid }) => {
  return axios({
    method: "POST",
    url: "/ac/estateforum_company/list",
    data: {
      acid
    }
  });
};
export const estateforum_create_company_info = ({
  acid,
  company,
  stockCode,
  person,
  phoneNum,
  position,
  status,
  sms
}) => {
  return axios({
    method: "POST",
    url: "/ac/estateforum_company/create",
    data: {
      acid,
      company,
      stockCode,
      person,
      phoneNum,
      position,
      status,
      sms
    }
  });
};
export const estateforum_update_company_info = ({
  id,
  acid,
  company,
  stockCode,
  person,
  phoneNum,
  position,
  status,
  sms
}) => {
  return axios({
    method: "PUT",
    url: "/ac/estateforum_company/update",
    data: {
      id,
      acid,
      company,
      stockCode,
      person,
      phoneNum,
      position,
      status,
      sms
    }
  });
};

//---个人&购票

export const creat_order_form = ({
  acid,
  company,
  person,
  position,
  phoneNum,
  email,
  card,
  ticketType,
  ticketTypePinyin,
  ticketNum
}) => {
  return axios({
    method: "POST",
    url: "/ac/estateforum_ticket/create",
    data: {
      acid,
      company,
      person,
      position,
      phoneNum,
      email,
      card,
      ticketType,
      ticketTypePinyin,
      ticketNum
    }
  });
};

//---------------嘉宾列表---------------------
export const guest_list = () => {
  return axios({
    method: "GET",
    url: `/acg/guest/list`
  });
};
//---------新增或者修改嘉宾
export const put_guest = ({ id, avatar, guName, summary, guType, guCity }) => {
  console.log("ido");
  if (id) {
    return axios({
      method: "PUT",
      url: `/acg/guest/update`,
      data: {
        id,
        avatar,
        guName,
        summary,
        guType,
        guCity
      }
    });
  } else {
    return axios({
      method: "post",
      url: `/acg/guest/add`,
      data: {
        avatar,
        guName,
        summary,
        guType,
        guCity
      }
    });
  }
};
export const guest_detail = id => {
  return axios({
    method: "get",
    url: `/acg/guest/${id}`
  });
};
export const guests_active = ({ id, active }) => {
  return axios({
    method: "PUT",
    url: `/acg/guest/active`,
    data: {
      id,
      active
    }
  });
};
//---------------新闻列表--------------------------
export const news_list = () => {
  return axios({
    method: "GET",
    url: `/acg/news/list`
  });
};
//---------新增或者修改新闻
export const put_news = ({
  id,
  imgUrl,
  link,
  title,
  summary,
  type,
  city,
  newsTime
}) => {
  if (id) {
    return axios({
      method: "PUT",
      url: `/acg/news/update`,
      data: {
        id,
        imgUrl,
        link,
        title,
        summary,
        type,
        city,
        newsTime
      }
    });
  } else {
    return axios({
      method: "post",
      url: `/acg/news/add`,
      data: {
        imgUrl,
        link,
        title,
        summary,
        type,
        city,
        newsTime
      }
    });
  }
};
export const news_detail = id => {
  return axios({
    method: "get",
    url: `/acg/news/${id}`
  });
};
export const news_active = ({ id, active }) => {
  return axios({
    method: "PUT",
    url: `/acg/news/active`,
    data: {
      id,
      active
    }
  });
};
// -------------花絮 -----------------------
export const shows_list = () => {
  return axios({
    method: "GET",
    url: `/acg/shows/list`
  });
};
//---------新增或者修改花絮
export const put_shows = ({ id, imgUrl, title, summary, type, city }) => {
  if (id) {
    return axios({
      method: "PUT",
      url: `/acg/shows/update`,
      data: {
        id,
        imgUrl,
        title,
        summary,
        type,
        city
      }
    });
  } else {
    return axios({
      method: "post",
      url: `/acg/shows/add`,
      data: {
        imgUrl,
        title,
        summary,
        type,
        city
      }
    });
  }
};
export const shows_detail = id => {
  return axios({
    method: "get",
    url: `/acg/shows/${id}`
  });
};
export const shows_active = ({ id, active }) => {
  return axios({
    method: "PUT",
    url: `/acg/shows/active`,
    data: {
      id,
      active
    }
  });
};
// -------------合作伙伴 -----------------------
export const parthers_list = () => {
  return axios({
    method: "GET",
    url: `/acg/parthers/list`
  });
};
//---------新增或者修改合作伙伴
export const put_parthers = ({
  id,
  pcImgUrl,
  mbImgUrl,
  type,
  city,
  name,
  link
}) => {
  if (id) {
    return axios({
      method: "PUT",
      url: `/acg/parthers/update`,
      data: {
        id,
        pcImgUrl,
        mbImgUrl,
        type,
        city,
        name,
        link
      }
    });
  } else {
    return axios({
      method: "post",
      url: `/acg/parthers/add`,
      data: {
        pcImgUrl,
        mbImgUrl,
        type,
        city,
        name,
        link
      }
    });
  }
};
export const parthers_detail = id => {
  return axios({
    method: "get",
    url: `/acg/parthers/${id}`
  });
};
export const parthers_active = ({ id, active }) => {
  return axios({
    method: "PUT",
    url: `/acg/parthers/active`,
    data: {
      id,
      active
    }
  });
};
//-----------------议程------------------
export const agenda_push = ({
  dateTime,
  acid,
  type,
  city,
  acTime,
  doing,
  title,
  guest,
  jobTitle,
  room,
  hotel,
  stock,
  company,
  startTime,
  endTime
}) => {
  return axios({
    method: "post",
    url: "/acg/agenda/push",
    data: {
      dateTime,
      acid,
      type,
      city,
      acTime,
      doing,
      title,
      guest,
      jobTitle,
      room,
      hotel,
      stock,
      company,
      startTime,
      endTime
    }
  });
};
export const agenda_put = ({
  id,
  dateTime,
  acid,
  type,
  city,
  acTime,
  doing,
  title,
  guest,
  jobTitle,
  room,
  hotel,
  stock,
  company,
  startTime,
  endTime
}) => {
  return axios({
    method: "put",
    url: "/acg/agenda/put",
    data: {
      id,
      dateTime,
      acid,
      type,
      city,
      acTime,
      doing,
      title,
      guest,
      jobTitle,
      room,
      hotel,
      stock,
      company,
      startTime,
      endTime
    }
  });
};
// ----------删除议程，传id和type
export const deleteAgenda = ({ type, id }) => {
  return axios({
    method: "post",
    url: "/acg/agenda/delete",
    data: {
      type,
      id
    }
  });
};

//-----------获取单个议程
export const agenda_detail = (dateTime, id) => {
  console.log(dateTime, id);
  return axios({
    method: "post",
    url: `/acg/agenda/detail`,
    data: {
      dateTime,
      id
    }
  });
};
//------------获取单个活动的所有列表
export const action_agenda_list = (dateTime, type, acid) => {
  console.log(dateTime, type, acid);
  return axios({
    method: "post",
    url: `/acg/agenda/actionlist`,
    data: {
      dateTime,
      type,
      acid
    }
  });
};
//---------获取所有活动的所有列表
export const agenda_list = dateTime => {
  return axios({
    method: "post",
    url: `/acg/agenda/allList`,
    data: {
      dateTime
    }
  });
};
//----------------------------------------------前端报名接口
// 获取活动报名已通过审核人员人数
export const checkSessionUserNumber = (acIdList, acType) => {
  return axios({
    url: "/fe/checkUserNumber",
    method: "post",
    data: {
      acIdList,
      acType
    }
  });
};
// ----------决战港股报名---------------//
// -----获取可报名城市信息
export const enroll_hkstocks_city_list = () => {
  return axios.get(`/fe/hkstocks/city_list`);
};
export const enroll_hkstocks_city = () => {
  return axios.get(`/fe/hkstocks/active_city_list`);
};
// ----------汇说报名---------------//
// -----获取可报名城市信息
export const enroll_freetalks_city = () => {
  return axios.get(`/fe/freetalks/stage_list`);
};
// ----------汇路演报名---------------//
// -----获取可报名城市信息
export const enroll_roadshow_city = () => {
  return axios.get(`/fe/roadshow/stage_list`);
};

//报名参加活动
export const add_user = ({
  acType,
  acId,
  job,
  company,
  name,
  mail,
  card,
  wechat,
  phone,
  phoneCode,
  property,
  hkstockPing,
  type,
  remark,
  concatPerson
}) => {
  return axios({
    method: "post",
    url: `/fe/add_user`,
    data: {
      acType,
      acId,
      job,
      company,
      name,
      mail,
      card,
      wechat,
      phone,
      phoneCode,
      remark,
      property,
      hkstockPing,
      type,
      concatPerson
    }
  });
};

// 检查是否有历史记录
export const check_user_history_info = phone => {
  return axios({
    method: "post",
    url: "/fe/check_uesr_history",
    data: {
      phone
    }
  });
};

// 检查用户当前活动填写状态
export const check_uesr_activity = (phone, actId, actType) => {
  return axios({
    method: "post",
    url: "/fe/check_uesr_activity_status",
    data: {
      phone,
      actId,
      actType,
    }
  });
};

// 输入手机号获取验证码
export const phone_get_code = ({
  countryCode,
  phone,
  challenge,
  validate,
  seccode
}) => {
  return axiosCross({
    method: "post",
    // url: "/api/road-show/sms",
    url: "/api/over-sea-sms/message-code",
    data: {
      countryCode,
      phone,
      challenge,
      validate,
      seccode
    }
  });
};

// 手机号注册or登陆
export const send_phone_code = ({ countryCode, phone, phoneCode }) => {
  return axiosCross({
    method: "post",
    // url: "/api/road-show/user/session/sms",
    url: "/api/v2/user/session",
    data: {
      countryCode,
      phone,
      phoneCode
    }
  });
};

// 输入手机号获取验证码
export const phone_get_code_glh = ({
  countryCode,
  phone,
  challenge,
  validate,
  seccode
}) => {
  return axiosCross({
    method: "post",
    // url: "/api/road-show/sms",
    url: "/api/over-sea-sms/message-code",
    data: {
      countryCode,
      phone,
      challenge,
      validate,
      seccode
    }
  });
};

// 手机号注册or登陆
export const send_phone_code_glh = ({ countryCode, phone, phoneCode }) => {
  return axiosCross({
    method: "post",
    // url: "/api/road-show/user/session/sms",
    url: "/api/v2/user/session",
    data: {
      countryCode,
      phone,
      phoneCode
    }
  });
};
// 合作申请报名
export const addCooperateEnroll = ({ ...form }) => {
  return axios({
    method: "post",
    url: "/fe/hkstock_cooperate",
    data: {
      ...form
    }
  });
};
// 合作申请列表
export const getEnrollList = ({ timeId, activeType }) => {
  return axios({
    method: "get",
    url: `/fe/hkstock_cooperate_list?timeId=${timeId}&activeType=${activeType}`
  });
};

// ------------------------ 榜单相关
export const getRankList = () => {
  return axios({
    method: "get",
    url: "/ac/rank"
  });
};
export const setRank = ({
  head,
  title,
  city,
  limit,
  status,
  type,
  startTime,
  expireTime
}) => {
  return axios({
    method: "post",
    url: "/ac/rank",
    data: {
      head,
      title,
      city,
      limit,
      status,
      type,
      startTime,
      expireTime
    }
  });
};
export const updateRank = ({
  id,
  head,
  title,
  city,
  limit,
  status,
  type,
  startTime,
  expireTime
}) => {
  return axios({
    method: "put",
    url: "/ac/rank",
    data: {
      id,
      head,
      title,
      city,
      limit,
      status,
      type,
      startTime,
      expireTime
    }
  });
};

// ------------------------ enroll相关
export const getEnrollAcList = () => {
  return axios({
    method: "get",
    url: "/ac/enroll"
  });
};

export const getEnrollDetail = id => {
  return axios({
    method: "get",
    url: `/ac/enroll/detail/${id}`
  });
};
export const setEnroll = ({
  head,
  title,
  city,
  limit,
  status,
  type,
  summary,
  startTime,
  expireTime,
  address,
  signupTime,
  noNeed
}) => {
  return axios({
    method: "post",
    url: "/ac/enroll",
    data: {
      head,
      title,
      city,
      limit,
      status,
      type,
      summary,
      startTime,
      expireTime,
      address,
      signupTime,
      noNeed
    }
  });
};
export const updateEnroll = ({
  id,
  head,
  title,
  city,
  limit,
  status,
  summary,
  type,
  startTime,
  expireTime,
  address,
  signupTime,
  noNeed
}) => {
  return axios({
    method: "put",
    url: "/ac/enroll",
    data: {
      id,
      head,
      title,
      noNeed,
      city,
      summary,
      limit,
      status,
      type,
      startTime,
      expireTime,
      address,
      signupTime
    }
  });
};



// WEBPACK FOOTER //
// ./src/api/api.js